import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "19",
  viewBox: "0 0 20 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]



export default /*@__PURE__*/_defineComponent({
  __name: 'FeelIcon',
  props: {
  color: {
    type: String,
    default: '#C671C2'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M7.35807 12.6074H12.8581V11.2324H7.35807V12.6074ZM6.89974 6.19076C6.41085 6.19076 5.95634 6.32826 5.5362 6.60326C5.11606 6.87826 4.76849 7.22964 4.49349 7.65742L5.63932 8.41367C5.7921 8.18451 5.97543 7.98971 6.18932 7.8293C6.40321 7.66888 6.64002 7.58867 6.89974 7.58867C7.15946 7.58867 7.39627 7.66888 7.61016 7.8293C7.82405 7.98971 8.00738 8.17687 8.16016 8.39076L9.30599 7.63451C9.03099 7.22201 8.68342 6.87826 8.26328 6.60326C7.84314 6.32826 7.38863 6.19076 6.89974 6.19076ZM13.3164 6.19076C12.8275 6.19076 12.373 6.32826 11.9529 6.60326C11.5327 6.87826 11.1852 7.22964 10.9102 7.65742L12.056 8.41367C12.2088 8.19978 12.3921 8.01263 12.606 7.85221C12.8199 7.6918 13.0567 7.61159 13.3164 7.61159C13.5761 7.61159 13.8168 7.68798 14.0383 7.84076C14.2598 7.99353 14.4393 8.18451 14.5768 8.41367L15.7227 7.65742C15.4477 7.22964 15.1001 6.87826 14.6799 6.60326C14.2598 6.32826 13.8053 6.19076 13.3164 6.19076ZM10.1081 18.5658C8.84002 18.5658 7.64835 18.3251 6.53307 17.8439C5.4178 17.3626 4.44766 16.7095 3.62266 15.8845C2.79766 15.0595 2.14453 14.0894 1.66328 12.9741C1.18203 11.8588 0.941406 10.6671 0.941406 9.39909C0.941406 8.13103 1.18203 6.93937 1.66328 5.82409C2.14453 4.70881 2.79766 3.73867 3.62266 2.91367C4.44766 2.08867 5.4178 1.43555 6.53307 0.954297C7.64835 0.473047 8.84002 0.232422 10.1081 0.232422C11.3761 0.232422 12.5678 0.473047 13.6831 0.954297C14.7984 1.43555 15.7685 2.08867 16.5935 2.91367C17.4185 3.73867 18.0716 4.70881 18.5529 5.82409C19.0341 6.93937 19.2747 8.13103 19.2747 9.39909C19.2747 10.6671 19.0341 11.8588 18.5529 12.9741C18.0716 14.0894 17.4185 15.0595 16.5935 15.8845C15.7685 16.7095 14.7984 17.3626 13.6831 17.8439C12.5678 18.3251 11.3761 18.5658 10.1081 18.5658ZM10.1081 16.7324C12.1553 16.7324 13.8893 16.022 15.3102 14.6012C16.731 13.1803 17.4414 11.4463 17.4414 9.39909C17.4414 7.35187 16.731 5.61784 15.3102 4.19701C13.8893 2.77617 12.1553 2.06576 10.1081 2.06576C8.06085 2.06576 6.32682 2.77617 4.90599 4.19701C3.48516 5.61784 2.77474 7.35187 2.77474 9.39909C2.77474 11.4463 3.48516 13.1803 4.90599 14.6012C6.32682 16.022 8.06085 16.7324 10.1081 16.7324Z",
      fill: __props.color
    }, null, 8, _hoisted_2)
  ]))
}
}

})